<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>待办事项</el-breadcrumb-item>
                </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="3">
                    <el-select size="small" v-model="status" placeholder="请选择状态">
                        <el-option label="未读" value="0"></el-option>
                        <el-option label="已读" value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="1">
                    <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary" size="small" @click="SetReads" plain>标为已读</el-button>
                </el-col>
                <el-col :span="18">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-sizes="pageSizes"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        style="float:right"
                    ></el-pagination>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="24">
                    <el-table :data="tableData" style="width: 100%" v-loading="loading" size="small" ref="registTable">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="Title" label="标题" width="300px"></el-table-column>
                        <!-- <el-table-column label="查看地址"><template slot-scope="scope"><a @click="SetRead(scope.row)">{{scope.row.Url}}</a></template></el-table-column> -->
                        <el-table-column label="当前状态"><template slot-scope="scope"><span v-if="scope.row.Status==1" style="color:#67C23A">已读</span><span v-else style="color:#F56C6C">未读</span></template></el-table-column>
                        <el-table-column label="消息类型"><template slot-scope="scope">{{ scope.row.Type==0?'KPI':(scope.row.Type==1?'考勤':'审批') }}</template></el-table-column>
                        <el-table-column prop="SendUserCode" label="发送人工号"></el-table-column>
                        <el-table-column prop="SendUserName" label="发送人姓名"></el-table-column>
                        <el-table-column prop="ReceiveUserCode" label="接收人工号"></el-table-column>
                        <el-table-column prop="ReceiveUserName" label="接收人姓名"></el-table-column>
                        <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                            <el-button type="text" @click="SetRead(scope.row)" size="small">处理</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row style="margin-top:5px;">
            </el-row>
        </el-card>
        
    </div>
</template>
<script>
    import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";  
    import{GetDoneMessageList,SetDoneMessageRead} from '../../until/ZeusApiSDK/Logic/HomeLogic';
    export default {
        data() {
            return {
                currentUser:{},//当前用户
                tableData:[],//接口数据
                loading:true,
                pageSizes: [10, 20, 50, 100, 200],
                pageSize: 10,
                pageIndex: 1,
                totalCount: 0,
                status:'',//选择状态
            };
        },
        methods: {
            //获取当前用户
            getCurrentUser:function(){
                var userinfo = window.sessionStorage.getItem("userinfo");
                userinfo = JSON.parse(Decrypt(userinfo));
                this.currentUser = userinfo;
            },
            //获取未读待办事项列表
            getNoReadList:function(){
                this.loading=true;
                var predicates=[
                {
                    Field:"IsDelete", 
                    Value:"0", 
                    Oper:"eq", //等于
                    IsAnd:1
                },{
                    Field:"ReceiveUserCode", 
                    Value:this.currentUser.UserCode, 
                    Oper:"eq", //等于
                    IsAnd:1
                }];
                if(this.status!=''){
                    if(this.status==0){
                        //未读
                        predicates.push({
                            Field:"Status", 
                            Value:"1", 
                            Oper:"neq", //不等於
                            IsAnd:1
                        })
                    }else if(this.status==1){
                        //已读
                        predicates.push({
                            Field:"Status", 
                            Value:"1", 
                            Oper:"eq", //不等於
                            IsAnd:1
                        })
                    }
                }
                
                GetDoneMessageList(predicates,this.pageIndex,this.pageSize,'status','asc').then(res=>{
                    this.tableData=res.DataList;
                    this.loading=false;
                    this.totalCount=res.TotalCount;
                });
            },
            //设为已读
            SetRead:function(data){
                //将未读设为已读
                SetDoneMessageRead(data.Id).then(res=>{
                    //打开新窗口页面 跳转到详情页
                    if(res=="success"){
                        //获取数据列表
                        this.getNoReadList();
                        var url=data.Url.split(',')[0];
                        //跳转到朝看页面
                        window.open(url, '_blank')
                        //刷新本页面
                        // window.location.href="/Done/DoneMessage";
                    }
                });
            },
            SetReads:function(){
                var _this=this;
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.2)'
                });
                var selections =this.$refs.registTable.selection
                if(selections.length>0){
                    selections.forEach(element => {
                        SetDoneMessageRead(element.Id).then(res=>{});
                    });
                    this.$message({
                        type: 'success',
                        duration:1000,
                        message: '恭喜，待办事项处理完成',
                        onClose:function(){
                            loading.close();
                            //获取数据列表
                            _this.getNoReadList();
                        }
                    });
                }
                else{
                    loading.close();
                    this.$message({
                        message: '请选择待办事项'
                    });
                }
            },
            //分页条件搜索
            handleSizeChange(val) {
                this.pageSize = val;
                //this.getFrameKpiScoreList();
                this.getNoReadList();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                //this.getFrameKpiScoreList();
                 this.getNoReadList();
            },
            SearchByName:function(){
                this.pageIndex =1;
                this.getNoReadList();
            },
            //刷新
            Refresh:function(){
                this.getNoReadList();
            }
        },
        //页面进入加载事件
        created:function(){
            //获取当前用户
            this.getCurrentUser();
            //获取数据列表
            this.getNoReadList();
        }

    }
</script>
<style lang="less" scoped>
/deep/ .el-table-column--selection .cell{ padding-left: 10px !important;}
</style>